import React from 'react';
import {Table} from 'antd';
import type {ColumnsType} from 'antd/es/table';
import {permColors} from '../../utils/colors';

interface ComparisonItem {
	key: string;
	feature: string;
	permworks: boolean;
	traditional: boolean;
	recruitingAgency: boolean;
}

interface ComparisonTableProps {
	title?: string;
	items?: ComparisonItem[];
}

const defaultItems: ComparisonItem[] = [
	{
		key: '1',
		feature: 'No middleman',
		permworks: true,
		recruitingAgency: true,
		traditional: false,
	},
	{
		key: '2',
		feature: 'No salary markup',
		permworks: true,
		recruitingAgency: true,
		traditional: false,
	},
	{
		key: '3',
		feature: 'Direct hiring',
		permworks: true,
		recruitingAgency: true,
		traditional: false,
	},
	{
		key: '4',
		feature: 'Cost efficient',
		permworks: true,
		recruitingAgency: false,
		traditional: false,
	},
	{
		key: '5',
		feature: 'Open application process',
		permworks: true,
		recruitingAgency: false,
		traditional: false,
	},
	{
		key: '6',
		feature: 'No lock-in contracts',
		permworks: true,
		recruitingAgency: false,
		traditional: false,
	},
	{
		key: '7',
		feature: 'AI-Powered Candidate Matching',
		permworks: true,
		recruitingAgency: false,
		traditional: false,
	},
	{
		key: '8',
		feature: 'Automated Candidate Screening',
		permworks: true,
		recruitingAgency: false,
		traditional: false,
	},
];

const ComparisonTable: React.FC<ComparisonTableProps> = ({title = 'What sets us apart?', items = defaultItems}) => {
	const columns: ColumnsType<ComparisonItem> = [
		{
			title: 'Feature',
			dataIndex: 'feature',
			key: 'feature',
		},
		{
			title: 'Permworks',
			dataIndex: 'permworks',
			key: 'permworks',
			align: 'center',
			render: (value) => (value ? '✓' : '✗'),
			className: 'permworks-column',
			onCell: () => ({
				style: {
					backgroundColor: permColors.backgroundGreyBlue,
					fontWeight: 'bold',
					color: permColors.deepBlue,
				},
			}),
			onHeaderCell: () => ({
				style: {
					backgroundColor: permColors.deepBlue,
					color: 'white',
					fontWeight: 'bold',
				},
			}),
		},
		{
			title: 'Recruiting agencies',
			dataIndex: 'recruitingAgency',
			key: 'recruitingAgency',
			align: 'center',
			render: (value) => (value ? '✓' : '✗'),
		},
		{
			title: 'BPO / Outsourcing agencies',
			dataIndex: 'traditional',
			key: 'traditional',
			align: 'center',
			render: (value) => (value ? '✓' : '✗'),
		},
	];

	return (
		<div className="flex flex-col items-center px-2 py-12 sm:py-20 bg-backgroundGrey/30">
			{title && <h2 className="text-2xl font-normal text-darkCharcoal mb-4">{title}</h2>}
			<Table columns={columns} dataSource={items} pagination={false} bordered className="w-[1050px] max-w-full" />
		</div>
	);
};

export default ComparisonTable;
